import { MemorySliceStore } from "../../shared";

/** Singleton in-memory store for session-only ephemeral slices. */
export const ephemeralStore = new MemorySliceStore();
